import { baseUrl } from 'src';
import { OrganizationRepresentation } from 'src/query/orgs';
import keycloak from '../keycloak';

const getUserOrgs = async () => {
  const user = await keycloak.loadUserProfile();

  try {
    const fOrgs = await fetch(`${baseUrl}/${keycloak.realm}/users/${user.id}/orgs`, {
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
      },
    });

    if (fOrgs.ok) {
      return await fOrgs.json();
    }
  } catch (e) {
    console.log('[Error] Fetching orgs');
    return [];
  }
};

const getUserOrgRoles = async (orgId: OrganizationRepresentation['id']) => {
  const user = await keycloak.loadUserProfile();

  try {
    const userOrgRolesFetch = await fetch(`${baseUrl}/${keycloak.realm}/users/${user.id}/orgs/${orgId}/roles`, {
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
      },
    });

    if (userOrgRolesFetch.ok) {
      return userOrgRolesFetch.json();
    }
  } catch (e) {
    console.log('[Error] Fetching org role for user');
    return [];
  }
};

const User = {
  getUserOrgs,
  getUserOrgRoles,
};

export default User;
